import LocalizationInterface from './LocalizationInterface';
import { LocalizationInterfaceType } from '@clientos/types';
import { getServices } from '../../../infra/startup';
import { Direction } from '../../../services/localizationService/constants';
import { ServiceLocalizationLanguageType } from '../../../services/localizationService/types';

export { createNoopLocalizationInterface } from './NoopInterface';

let localizationInterface: LocalizationInterface;

export function getLocalizationInterface(): LocalizationInterface {
  return localizationInterface;
}

export default async function initializeLocalizationInterface(): Promise<LocalizationInterfaceType> {
  if (localizationInterface) return localizationInterface.getInterface();

  localizationInterface = new LocalizationInterface();

  return localizationInterface.getInterface();
}
